<div class="page-layout blank py-8 px-24" fusePerfectScrollbar>
  <div fxLayout="column" fxLayoutAlign="start stretch" class="formArrayClass">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="single-box-form-container"
    >
      <h3 class="accent-fg text-uppercase font-weight-600 text-italic">
        Weight and Dimensions
      </h3>
    </div>
    <form [formGroup]="singleBoxForm">
      <div class="form-border">
        <div>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Select Box</mat-label>
            <mat-select
              formControlName="box"
              (selectionChange)="handleBoxChange($event)"
            >
              <mat-option *ngIf="!!boxList?.length">
                <ngx-mat-select-search
                  [(ngModel)]="searchText"
                  [ngModelOptions]="{ standalone: true }"
                  placeholderLabel="Search..."
                  noEntriesFoundLabel="No matching box found."
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngIf="!searchText" value=""> None </mat-option>
              <mat-option
                *ngFor="let box of boxList | stringFilterBy: searchText:'name'"
                [value]="box._id"
              >
                {{ box.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-sm="column"
          fxLayoutGap="0px"
          fxLayoutGap.gt-xs="20px"
        >
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Length</mat-label>
            <span matSuffix>cm</span>
            <input
              matInput
              formControlName="length"
              maxlength="10"
              decimals
              required
            />
            <mat-error>
              <error-message
                fieldName="Length"
                [formControlErr]="singleBoxForm?.controls?.length"
                patternMsg="Only positive numbers upto 2 decimal digits."
              ></error-message>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Breadth</mat-label>
            <span matSuffix>cm</span>
            <input
              matInput
              formControlName="breadth"
              maxlength="10"
              decimals
              required
            />
            <mat-error>
              <error-message
                fieldName="Breadth"
                [formControlErr]="singleBoxForm?.controls?.breadth"
                patternMsg="Only positive numbers upto 2 decimal digits."
              ></error-message>
            </mat-error>
          </mat-form-field>
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-sm="column"
          fxLayoutGap="0px"
          fxLayoutGap.gt-xs="20px"
        >
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Height</mat-label>
            <span matSuffix>cm</span>
            <input
              matInput
              formControlName="height"
              maxlength="10"
              decimals
              required
            />
            <mat-error>
              <error-message
                fieldName="Height"
                [formControlErr]="singleBoxForm?.controls?.height"
                patternMsg="Only positive numbers upto 2 decimal digits."
              ></error-message>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Weight</mat-label>
            <span matSuffix>kg</span>
            <input
              matInput
              formControlName="weight"
              maxlength="10"
              decimals
              required
            />
            <mat-error>
              <error-message
                fieldName="Weight"
                [formControlErr]="singleBoxForm?.controls?.weight"
                patternMsg="Only positive numbers upto 2 decimal digits."
              ></error-message>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
